import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ContainerStatus, ContainerType } from 'src/app/enum/enum';
import { containerRequestModel, containerResponse } from '../Model/Container';

@Injectable({
  providedIn: 'root'
})
export class ContainersService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  //  Containers Service
  getAllContainers(
    companyId: number,
    StoreId?: number,
    status?: ContainerStatus,
    type?: ContainerType,
    searchText?: string
  ) {
    let params = new HttpParams().set('CompanyId', companyId.toString());

    if (type != null) {
      params = params.set('Type', type.toString());
    } else {
      params = params.set('Type', ContainerType.Production.toString());
    }

    if (status != null) {
      params = params.set('Status', status.toString());
    }

    if (StoreId != null && StoreId > 0) {
      params = params.set('StoreId', StoreId.toString());
    }
    if (searchText && searchText.trim().length > 0) {
      params = params.set('SearchTerm', searchText.trim());
    }

    const url = `${this.baseUrl}Containers`;
    return this.http.get<containerResponse[]>(url, { params });
  }

  getContainerById(id: number) {
    const url = `${this.baseUrl}Containers/${id}`;
    return this.http.get<containerResponse>(url);
  }


  createContainer(containerObj: containerRequestModel) {
    const url = `${this.baseUrl}Containers`;
    return this.http.post(url, containerObj);
  }

  updateContainer(id: number, containerObj: containerRequestModel) {
    const url = `${this.baseUrl}Containers/${id}`;
    return this.http.put(url, containerObj);
  }

  updateContainerStatus(id: number, status: ContainerStatus) {
    const url = `${this.baseUrl}Containers/${id}/status`;
    return this.http.put(url, { status });
  }

  deleteContainer(id: number) {
    const url = `${this.baseUrl}Containers/${id}`;
    return this.http.delete(url);
  }
}
